export const messages = {
  en: {
    printSmallPayFee: {
      receipt: 'Payment Receipt',
      receiptNum: 'Receipt No:',
      orderNum: 'Order No:',
      roomNum: 'Room No',
      owner: 'Owner',
      time: 'Time',
      feeItem: 'Fee Item',
      feeRange: 'Fee Range',
      to: 'to',
      unitPrice: 'Unit Price/Fixed Fee:',
      areaUsage: 'Area/Usage:',
      paymentMethod: 'Payment Method:',
      meterReading: 'Meter Reading:',
      amount: 'Amount:',
      refund: '(Refund)',
      discount: 'Discount Amount:',
      remark: 'Remark',
      total: 'Total',
      issuer: 'Issuer',
      print: 'Print',
      cloudPrint: 'Cloud Print',
      cancel: 'Cancel',
      submit: 'Submit',
      printer: 'Printer',
      printerRequired: 'Required, please select printer',
      quantity: 'Quantity',
      quantityRequired: 'Required, please enter quantity',
      noFee: 'No fee included',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Submission failed'
    }
  },
  zh: {
    printSmallPayFee: {
      receipt: '缴费收据单',
      receiptNum: '收据号：',
      orderNum: '订单号：',
      roomNum: '房号',
      owner: '业主',
      time: '时间',
      feeItem: '收费项目',
      feeRange: '收费范围',
      to: '至',
      unitPrice: '单价/固定费：',
      areaUsage: '面积/用量：',
      paymentMethod: '支付方式：',
      meterReading: '表读数：',
      amount: '金额：',
      refund: '(退费)',
      discount: '优惠金额：',
      remark: '备注',
      total: '总计',
      issuer: '开票人',
      print: '打印',
      cloudPrint: '云打印',
      cancel: '取消',
      submit: '提交',
      printer: '打印机',
      printerRequired: '必填，请选择打印机',
      quantity: '数量',
      quantityRequired: '必填，请填写数量',
      noFee: '未包含费用',
      submitSuccess: '提交成功',
      submitFailed: '提交失败'
}
  },
  'zh-TW': {
    printSmallPayFee: {
      receipt: '繳費收據單',
      receiptNum: '收據號：',
      orderNum: '訂單號：',
      roomNum: '房號',
      owner: '業主',
      time: '時間',
      feeItem: '收費項目',
      feeRange: '收費範圍',
      to: '至',
      unitPrice: '單價/固定費：',
      areaUsage: '面積/用量：',
      paymentMethod: '支付方式：',
      meterReading: '表讀數：',
      amount: '金額：',
      refund: '(退費)',
      discount: '優惠金額：',
      remark: '備註',
      total: '總計',
      issuer: '開票人',
      print: '列印',
      cloudPrint: '雲列印',
      cancel: '取消',
      submit: '提交',
      printer: '印表機',
      printerRequired: '必填，請選擇印表機',
      quantity: '數量',
      quantityRequired: '必填，請填寫數量',
      noFee: '未包含費用',
      submitSuccess: '提交成功',
      submitFailed: '提交失敗'
    }
  }
}